/**
 * Represents an Error Object that is returned by the API Server.
 */
export class ApiError extends Error {
	/**
	 * An UPPER_SNAKE_CASE identifier for this Error.
	 * This should be unique not change.
	 */
	public code: string;
	/**
	 * Additional Message returned by the Server.
	 * Do not depend on the message containing specific data, it may change without notice or depend on params and other variables.
	 */
	public message: string;
	/**
	 * Any extra data returned for the Error.
	 * This may be used to get further details about the Error
	 */
	public data: any;

	constructor(code: string, message: string, data: any) {
		super(message);
	}
}



// WEBPACK FOOTER //
// ./src/lib/api/ApiError.ts